export const buildingSearchColumns = [
  { id: "display_full_street_address", label: "Address", alwaysVisible: true, sortable: true },
  { id: "neighborhood", label: "Neighborhood", defaultVisible: true, sortable: true },
  { id: "borough", label: "Borough", defaultVisible: true, sortable: true },
  { id: "property_category", label: "Category", defaultVisible: true, sortable: true },
  { id: "ownership_type", label: "Ownership", defaultVisible: true, sortable: true },
  { id: "year_built", label: "Year Built", defaultVisible: true, sortable: true },
  { id: "total_floors", label: "Floors", defaultVisible: true, sortable: true },
  { id: "total_units", label: "Total Units", defaultVisible: true, sortable: true },
  { id: "residential_units", label: "Res. Units", defaultVisible: false, sortable: true },
  { id: "inventory_total", label: "Inventory Total", defaultVisible: false, sortable: true },
  { id: "inventory_unsold", label: "Inventory Unsold", defaultVisible: false, sortable: true },
  { id: "inventory_active", label: "Active Listings", defaultVisible: false, sortable: true },
  { id: "building_effective_start", label: "CO/TCO Issued", defaultVisible: false, sortable: true },
  { id: "sales_start_date", label: "Sales Start", defaultVisible: false, sortable: true },
  { id: "offering_submitted_date", label: "OP Submitted", defaultVisible: false, sortable: true },
  { id: "offering_accepted_date", label: "OP Accepted", defaultVisible: false, sortable: true },
  { id: "marketing_company", label: "Marketing Co.", defaultVisible: false, sortable: false },
  { id: "developers", label: "Developers", defaultVisible: false, sortable: false },
  { id: "architect", label: "Architect", defaultVisible: false, sortable: false },
  { id: "owner", label: "Owner", defaultVisible: false, sortable: false },
  { id: "lenders", label: "Lenders", defaultVisible: false, sortable: false },
  { id: "building_status", label: "Status", defaultVisible: false, sortable: true },
  { id: "building_category", label: "Building Type", defaultVisible: false, sortable: true },
  { id: "type", label: "Type", defaultVisible: false, sortable: true },
  { id: "zip", label: "ZIP", defaultVisible: false, sortable: true },
  { id: "solr_updated", label: "Last Updated", defaultVisible: false, sortable: true },
];

export const defaultVisibleColumns = buildingSearchColumns
  .filter(c => c.alwaysVisible || c.defaultVisible)
  .map(c => c.id);
